import styled from "styled-components";

const H1 = styled.h1`
	font-size: 26px;
	font-weight: bold;
`;

const H2 = styled.h2`
	font-size: 20px;
	font-weight: bold;
`;

const H3 = styled.h3`
	font-size: 16px;
	font-weight: bold;
`;

const H4 = styled.h4`
	font-size: 15px;
	font-weight: 600;
`;

const H5 = styled.h5`
	font-size: 14px;
	font-weight: bold;
`;

const H6 = styled.h6`
	font-size: 15px;
	font-weight: 400;
`;

const Text = styled.span`
	${({ size }) => size === "small" && "font-size:10pt;"};
	margin-bottom: 0;
	padding-bottom: 0;
`;

export default { H1, H2, H3, H4, H5, H6, Text };
